.j{align-items:center;}